<template>
  <div class="out_box">
    <div>工具任务箱</div>
    <div class="tool_box">
      <div v-for="(item, index) in toolList" class="tool_item" :class="{isActive: activeTool == index}" @click="changeTool(index)">
        <div>{{item.title}}</div> 
        <div class="tool_btm">
          {{item.num}}
          <div class="tool_btm_r">
            <!-- <div :style="{background: item.color}" class="tool_btm_f">
              {{item.fluctuate}}
              <img :src="require('@/assets/images/fluctuate-'+item.type+'.png')" alt="">
            </div> -->
            个任务
          </div>
        </div>
      </div>
    </div>
    <ExcelTable type="dashboard" v-if="activeTool == 3" />
    <el-table
      v-else
      :data="tableData"
      class="main_table">
      <el-table-column
        prop="batch_number"
        label="批次">
        <template slot-scope="scope">
          <div class="exceedomit" v-if="activeTool != 2">{{ scope.row.remarks }}</div>
          <div>{{ scope.row.batch_number }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="任务数量">
        <template slot-scope="scope">
          任务数量：{{scope.row.num}}
          <el-divider direction="vertical"></el-divider>
          <span :style="{color: successNum(scope.row) ? '#3FBF72' : '#A6A6A6'}" v-if="activeTool == 2">完成数量：{{successNum(scope.row)}}</span> 
          <span :style="{color: scope.row.completed_num ? '#3FBF72' : '#A6A6A6'}" v-else>完成数量：{{scope.row.completed_num}}</span> 
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="任务进度">
        <template slot-scope="scope">
          <el-progress v-if="activeTool == 2" :percentage="scope.row.num?Number(((successNum(scope.row)/scope.row.num)*100).toFixed(0)):0" :color="percentColors"></el-progress>
          <el-progress v-else :percentage="parseInt((scope.row.completed_num / scope.row.num) * 100)" :color="percentColors"></el-progress>
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="状态">
        <template slot-scope="scope">
          <div v-if="activeTool == 2">
            {{ scope.row.status==0?'未开始':scope.row.status==1?'进行中':scope.row.status==2?'已完成':scope.row.status==3?'已取消':'未知' }}
          </div>
          <div v-else>
            <div v-if="scope.row.status == 0" class="table_type2">已取消</div>
            <div v-else>
              <div v-if="scope.row.completed_num == 0" class="table_type1">未生成</div>
              <div v-else-if="scope.row.completed_num / scope.row.num < 0.5" class="table_type3">
                生成中
              </div>
              <div v-else-if="scope.row.completed_num / scope.row.num < 0.75" class="table_type3">
                生成中
              </div>
              <div v-else-if="scope.row.completed_num / scope.row.num == 1" class="table_type4">
                完成
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间" />
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="toDetail(scope.row.id)">查看详情</el-button>
          <el-button type="text" v-if="activeTool != 2 && scope.row.status == 1 && scope.row.completed_num != scope.row.num" @click="handleCancel(scope.row.id)">终止任务</el-button>
          <!-- <el-button type="text" disabled>下载</el-button> -->
          <el-button slot="reference" type="text" v-if="activeTool != 2 && userInfo.id == scope.row.user.id" @click="toRemark(scope.row)">备注</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="activeTool != 3"
      class="main_pagination"
      background
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :page-size="searchForm.limit"
      :total="tableTotal">
    </el-pagination>
  </div>
</template>
<script>
import { aiGetStatistics, aiGetList, aiRemark, aiDelete } from '@/api/imgAndText'
import { templateTaskGetList } from "@/api/templateTask";

import ExcelTable from '@/components/ExcelTable.vue'
export default {
  name: "dashboard",
  components: {ExcelTable},
  data () {
   return {
    activeTool: 0,
    toolList: [{
      title: '图裂变',
      // fluctuate: '20%',
      type: 'up',
      color: '#FF5733',
      num: 50
    },{
      title: '文生图',
      // fluctuate: '2.3%',
      type: 'up',
      color: '#ADFBC4',
      num: 150
    },{
      title: '商品套图',
      // fluctuate: '2.3%',
      type: 'down',
      color: '#E39E71',
      num: 78
    },{
      title: '导出模板',
      // fluctuate: '2.3%',
      type: 'down',
      color: '#E39E71',
      num: 78
    }
    // {
    //   title: '一键抠图',
    //   fluctuate: '2.3%',
    //   type: 'down',
    //   color: '#F2A39C',
    //   num: 150
    // },{
    //   title: '标题提取',
    //   fluctuate: '20%',
    //   type: 'up',
    //   color: '#FF5733',
    //   num: 98
    // }
    ],
    searchForm: {
      page: 1,
      limit: 10
    },
    tableData: [],
    tableTotal: 0,
    percentColors: [
      {color: '#FF5733', percentage: 50},
      {color: '#A5D63F', percentage: 75},
      {color: '#3FBF72', percentage: 100},
    ]
   }
  },
  created() {
    aiGetStatistics().then(res => {
      this.toolList[0].num = res.data.image_to_image_count
      this.toolList[1].num = res.data.text_to_image_count
      this.toolList[2].num = res.data.template_task_count
      this.toolList[3].num = res.data.excel_count
    })
    this.getTypesList()
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    successNum(detailData){
      let success_num = 0;
      detailData.materialGroups?.forEach((materialG) => {
        let is_success=true;
        detailData.images.forEach((img) => {
          if (img.group_id==materialG.id && img.status != 2) {
            is_success = false;
          }
        });
        if(is_success){
          success_num++;
        }
      });
      return success_num;
    }
  },
  methods:{
    changeTool(index) {
      this.activeTool = index
      this.getTypesList()
    },
    toDetail(id){
      this.$router.push({
        path: "/toolbox/"+ (this.activeTool == 0 ? 'figures' : this.activeTool == 1 ? 'texts' : 'setPicture') + "/detail",
        query: {
          id: id,
        },
      });
    },
    toRemark(row) {
      var _this = this;
      let remarkContent = row.remarks || '';
      this.$prompt('', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        inputPlaceholder: '请输入备注',
        inputType: 'textarea',
        inputValue: remarkContent,
        inputAttributes: { rows: 5 }
      }).then(({ value }) => {
        let type = this.activeTool == 0 ? 'image_image' : 'text_image'
        aiRemark({type: type, task_id: row.id, remarks: value}).then(res => {
          _this.$message.success('备注成功');
          _this.getTypesList()
        })
      }).catch(() => {
      });
    },
    handleCancel(id) {
      this.$confirm('是否终止该任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        aiDelete(id).then(res => {
          this.getTypesList()
          this.$message.success('任务终止成功');
        })
      })
    },
    getTypesList() {
      let datas = {...this.searchForm}
      if(this.activeTool == 2) {
        // 商品套图
        templateTaskGetList(datas).then((res) => {
          this.tableData = res.data.data
          this.tableTotal = res.data.total
        })
      } else if(this.activeTool == 3) {
        // 导出模板

      }else {
        datas.type = this.activeTool == 0 ? 'image_image' : 'text_image'
        aiGetList(datas).then(res => {
          this.tableData = res.data.list
          this.tableTotal = res.data.total
        })
      }
    },
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.getTypesList()
    }
  }
}
</script>
<style lang="scss" scoped>
.out_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  font-size: 16px;
  .tool_box {
    display: flex;
    align-items: center;
    // justify-content: space-between;
    gap: 24px;
    margin-top: 24px;
    .tool_item {
      width: 18.5%;
      background: #F2F2F2;
      color: #808080;
      border-radius: 2px;
      padding: 12px 32px 20px;
      cursor: pointer;
      .tool_btm {
        margin-top: 24px;
        display: flex;
        align-items: center;
        font-size: 48px;
        font-weight: 700;
        color: #262626;
        .tool_btm_r {
          color: #737373;
          font-size: 12px;
          margin-left: 16px;
          margin-top: 24px;
          .tool_btm_f {
            width: 60px;
            height: 20px;
            border-radius: 25px;
            color: #000000;
            font-size: 12px;
            text-align: center;
            line-height: 20px;
            margin-bottom: 8px;
            img {
              width: 10px;
              margin-left: 2px;
            }
          }
        }
      }
      &.isActive {
        color: #FFFFFF;
        background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
        .tool_btm {
          color: #FFFFFF;
          .tool_btm_r {
            color: #E0E0E0;
          }
        }
      }
    }
  }
  .table_type1, .table_type2, .table_type3, .table_type4 {
    width: 60px;
    height: 20px;
    text-align: center;
    line-height: 17px;
    font-size: 12px;
    border-radius: 4px;
  }
  .table_type1 {
    color: #333333;
    background: rgba(191, 191, 191, 0.3);
    border: 1px solid #BFBFBF;
  }
  .table_type2 {
    color: #FF5733;
    background: rgba(255, 87, 51, 0.35);
    border: 1px solid #FF5733;
  }
  .table_type3 {
    color: #729E13;
    background: rgba(165, 214, 63, 0.35);
    border: 1px solid #A5D63F;
  }
  .table_type4 {
    color: #3EC775;
    background: rgba(179, 252, 209, 0.3);
    border: 1px solid #3FBF72;
  }

}
</style>